import { adjustmentSignByType, sortUsers } from "globalResources/util";
import moment from "moment-timezone";

function calculateTimes(group, client) {
  return new Promise((resolve, reject) => {
    let totals = {
      hours: 0,
      paid: 0,
      billed: 0,
      overtimePaid: 0,
      overtimeBilled: 0,
      overtimeHours: 0,
      profit: 0,
      total: 0,
    };
    if (group.times) {
      group.times.sort((a, b) => (a.start > b.start ? 1 : -1));
      group.times.forEach((time) => {
        let diff =
          Math.round(
            (moment
              .duration(moment(time.end).diff(moment(time.start)))
              .asHours() -
              (time.subtractLunch && !group.user.overrideLunch ? 0.5 : 0)) *
              100,
          ) / 100;

        if (totals.hours > 40) {
          totals.hours += diff;
          totals.overtimePaid +=
            (diff * Math.round(time.overtimePayRate)) / 100;
          totals.overtimeBilled +=
            (diff * Math.round(time.overtimeBillRate)) / 100;
        } else if (diff + totals.hours > 40) {
          totals.hours += diff;
          let overtime = totals.hours - 40;
          totals.paid += ((diff - overtime) * Math.round(time.payRate)) / 100;
          totals.billed +=
            ((diff - overtime) * Math.round(time.billRate)) / 100;
          totals.overtimePaid +=
            (overtime * Math.round(time.overtimePayRate)) / 100;
          totals.overtimeBilled +=
            (overtime * Math.round(time.overtimeBillRate)) / 100;
        } else {
          totals.hours += diff;
          totals.paid += (diff * time.payRate) / 100;
          totals.billed += (diff * time.billRate) / 100;
        }
      });
    }
    totals.total = totals.billed + totals.overtimeBilled;
    totals.profit = totals.total - totals.paid - totals.overtimePaid;
    totals.overtimeHours = totals.hours > 40 ? totals.hours - 40 : 0;
    group.totals = totals;
    resolve(group);
  });
}

function groupedTotals(groups, client) {
  return new Promise((resolve, reject) => {
    groups.forEach((group) => calculateTimes(group, client));
    resolve(groups);
  });
}

function getTotals(groups, adjustments) {
  let totals = {
    hours: 0,
    paid: 0,
    overtimePaid: 0,
    billed: 0,
    overtimeBilled: 0,
    profit: 0,
    total: 0,
    adjustments: 0,
    overtimeHours: 0,
  };
  if (adjustments)
    adjustments.forEach(
      (adj) =>
        (totals.adjustments += adjustmentSignByType(adj.type) * adj.amount),
    );
  totals.adjustments = totals.adjustments / 100;
  return new Promise((resolve, reject) => {
    groups.forEach((group) => {
      totals.hours += group.totals.hours;
      totals.paid += group.totals.paid;
      totals.overtimePaid += group.totals.overtimePaid;
      totals.billed += group.totals.billed;
      totals.overtimeBilled += group.totals.overtimeBilled;
      totals.profit += group.totals.profit;
      totals.total += group.totals.total;
      totals.overtimeHours += group.totals.overtimeHours;
    });
    resolve(totals);
  });
}

export async function calculateReportTotals(reports, onDone) {
  let temp = Object.assign({}, reports);
  temp.timesheets.sort((a, b) => sortUsers(a, b));
  let results = await groupedTotals(temp.timesheets, temp.client);
  getTotals(results, temp.adjustments).then((totals) =>
    onDone({
      report: reports,
      groups: results,
      totals: totals,
    }),
  );
}
